import { render } from "./IconButton.vue?vue&type=template&id=0e3a903d&scoped=true&ts=true"
import script from "./IconButton.vue?vue&type=script&lang=ts"
export * from "./IconButton.vue?vue&type=script&lang=ts"

import "./IconButton.vue?vue&type=style&index=0&id=0e3a903d&lang=css&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3a903d"]])

export default __exports__